<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.contactlist') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <div
        v-if="ready"
        class="col-md-12 no-padding">
        <table
          id="dataTable"
          class="table table-bordered"
          style="width: 100%;">
          <thead>
            <tr>
              <th>{{ $t('message.name') }}</th>
              <th
                class="text-center"
                style="width: 15%;"/>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in partners">
              <tr v-if="item.type == 'customer'">
                <td>
                  <router-link-custom
                    :to="{name: 'ContactCustomerEdit', query: {cus_id: item.customer_id, cus_name: item.customer_name}}"
                    :text="item.customer_name"
                    :to_appid="11"
                    :current_appid="11"/>
                </td>
                <td
                  class="text-center"
                  style="width: 15%;">
                  {{ $t('message.customer') }}
                </td>
              </tr>
              <tr v-if="item.type == 'vendor'">
                <td>
                  <router-link-custom
                    :to="{name: 'ContactVendorEdit', query: {ven_id: item.vendor_id, ven_name: item.vendor_name}}"
                    :text="item.vendor_name"
                    :to_appid="11"
                    :current_appid="11"/>
                </td>
                <td
                  class="text-center"
                  style="width: 15%;">
                  {{ $t('message.vendor') }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'

export default {
  name: 'ContactListAll',
  data () {
    return {
      ready: false,
    }
  },
  computed: mapGetters({
    partners: 'getPartners',
  }),
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
      // dataTable option
      let option = this.dataTableOption()
      // set dataTable
      setTimeout(() => { $('#dataTable').DataTable(option) }, 1)
    },
  },
  beforeCreate: function () {

  },
  created: async function () {
    // get partners
    await this.$store.dispatch('getPartners')
    // set ready
    this.ready = true
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.contacts.title'),
      current: {
        app_name: 'contacts',
        app_id: 11,
        module_id: 1,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 0,
    })
  },
  mounted: function () {

  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearPartners'])
  },
  methods: {

  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/contact/list/All.vue